<template>
  <el-main class="container">
    <Nav>
      <div class="left" slot="left">
        <el-input
          type="text"
          clearable
          v-model.trim="body.word"
          @click="event().search()"
          placeholder="请输入企业名称搜索"></el-input>
        <el-button type="primary">搜索</el-button>
      </div>
      <div class="right" slot="right">
        <el-button
          v-show="hasAuthority('addServeCompany')"
          type="primary"
          class="excel"
          @click="handlerAdd()">
          新增服务企业</el-button>
      </div>
    </Nav>
    <table-pagination
      ref="table"
      :config="config"
      :idRow="false"
      :width="300"
      :datasource="datasource"
      @change-page="handlerPageChange">
      <el-table-column
        slot="action"
        fixed="right"
        label="操作"
        align="center">
        <template slot-scope="scope">
          <div>
            <el-link
              v-show="hasAuthority('serveMessage')"
              :underline="false"
              type='primary'
              class="details"
              @click="handlerRouter('message', scope)">
              留言意向</el-link>
            <el-link
              v-show="hasAuthority('editServeCompany')"
              style="margin-left: 5px"
              :underline="false"
              type='primary'
              class="details"
              @click="handlerRouter('set', scope)">
              编辑</el-link>
            <el-link
              v-show="hasAuthority('deleteServeCompany')"
              style="margin-left: 5px"
              :underline="false"
              type='primary'
              class="details"
              @click="event().deleteServe(scope)">
              删除</el-link>
          </div>
        </template>
      </el-table-column>
    </table-pagination>
  </el-main>
</template>

<script>
import Nav from '@/components/nav'
import TablePagination from '@/components/table-pagination'
import { getServeList, deleteCompanyServe } from '@/api/serve'
export default {
  data() {
    return {
      body: {
        pageSize: 10,
        pageIndex: 1,
        word: ''
      },
      config: {
        size: 10,
        fields: [
          {
            prop: 'indexNum',
            label: '排列序号'
          },
          {
            prop: 'name',
            label: '企业名称'
          },
          {
            prop: 'picture',
            label: '企业logo',
            type: 'image',
            width: '320',
            imgH: '100',
            imgW: '100'
          },
          {
            prop: 'industryName',
            label: '所属产业'
          },
          {
            prop: 'typeName',
            label: '所属分类'
          }
        ]
      },
      datasource: {
        total: 0,
        data: []
      }
    }
  },
  created() {
    this.network().getServeList()
  },
  methods: {
    event() {
      return {
        deleteServe: (scope) => {
          this.$confirm('是否删除该服务管理？', '删除', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.network().deleteCompanyServe(scope.row.uuid)
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除'
            })
          })
        },
        search: () => {
          this.network().getServeList()
        }
      }
    },
    network() {
      return {
        getServeList: async() => {
          const { data } = await getServeList(this.body)
          this.datasource.total = data.total
          this.datasource.data = data.list
        },
        deleteCompanyServe: async(uuid) => {
          await deleteCompanyServe(uuid)
          this.$message({
            type: 'success',
            message: '删除成功!'
          })
          this.network().getServeList()
        }
      }
    },
    handlerPageChange(data) {
      this.body.pageIndex = data.page
      this.network().getServeList()
    },
    handlerAdd() {
      this.$router.push({ path: '/serve-management/serve-management-management/add' })
    },
    handlerRouter(type, scope) {
      if (type === 'set') {
        this.$router.push({ path: `/serve-management/serve-management-management/set/${scope.row.uuid}` })
      } else if (type === 'message') {
        this.$router.push({ path: '/serve-management/message-management', query: { uuid: scope.row.uuid }})
      }
    }
  },
  components: {
    Nav,
    TablePagination
  }
}
</script>

<style scoped lang="scss">
</style>
